var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "artist"
  }, [_c('h4', [_vm._v(_vm._s(_vm.q))]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.tracks), function(track) {
    return _c('div', {
      staticClass: "trackitem"
    }, [_c('small', {
      staticClass: "text-secondary"
    }, [_vm._v("\n      Episodes:\n      "), _vm._l((_vm.trackEpisodes(track.id)), function(episode) {
      return _c('span', {
        staticClass: "btn btn-sm"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'Episode',
            params: {
              number: episode.number
            }
          }
        }
      }, [_vm._v(_vm._s(episode.number))]), _vm._v(" "), _c('a', {
        staticClass: "play-icon",
        attrs: {
          "href": _vm.audioAtTime(episode, track.id),
          "target": "_blank"
        }
      }, [_c('svg', {
        staticClass: "icon"
      }, [_c('use', {
        attrs: {
          "xlink:href": "#play"
        }
      })])])], 1)
    })], 2), _vm._v(" "), _c('track-row', {
      attrs: {
        "track-id": track.id
      }
    })], 1)
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92183b74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Artist.vue
// module id = alYc
// module chunks = 1